// action类似与mutation，action提交的是mutation而不是直接变更状态，action可以包含任意一步操作
const actions = {};

export default actions;
